import { useEffect, useContext, useCallback } from "react";
import { LoginContext } from "../loginContext";
import { getEhrUserId, getPatientId } from "../utils/urlParams";
import { logPageAccess } from "../api";

export const useAuditLog = (pageName: string, action?: string) => {
    const { userId: entraUserId, ehrUserId } = useContext(LoginContext);
    const patientId = getPatientId();

    useEffect(() => {
        if (patientId) {
            // Only log if viewing a patient
            logPageAccess(pageName, entraUserId, ehrUserId, patientId, action).catch(err => console.error("Audit log failed:", err));
        }
    }, [pageName, entraUserId, ehrUserId, patientId, action]);

    const logQuestion = useCallback(
        (question: string) => {
            if (patientId) {
                logPageAccess(pageName, entraUserId, ehrUserId, patientId, "question", question).catch(err => console.error("Audit log question failed:", err));
            }
        },
        [pageName, entraUserId, ehrUserId, patientId]
    );

    return { entraUserId, ehrUserId, patientId, logQuestion };
};
